import React, { Component } from 'react';
import { withRouter } from 'react-router'
import Constants from './Constants.js';
import $ from 'jquery';
import moment from 'moment';

class ActiveNewUsers extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: []
    };
  }

  componentWillMount() {
  	const self = this;

		$.ajax({
      type: 'GET',
      url: `${Constants.API_HOST}metrics/active_new_users/`,
      contentType: 'application/json',
      dataType: "json",
      xhrFields: { withCredentials:true },
      success: function success(data) {
      	self.setState({
      		'users': data
      	})

      },
      error: function error(data) {

      }
    });

  }

  render() {
    return (
      <div>
      	<h1>Active New Users</h1>
        <p>
          Consists of users that have:
          <ul>
            <li>Signed up within the past week</li>
            <li>Opened Literator 2+ times</li>
            <li>Added 1+ students</li>
          </ul>            
        </p>
				<table className="table">
					<thead>
						<tr>
							<th>
								Email
							</th>
							<th>
								Student Count
							</th>
							<th>
								Num Days Active
							</th>
							<th>
								Days Active
							</th>
							<th>
								Date Joined
							</th>
						</tr>
					</thead>
          <tbody>
          {
            this.state.users.map(function(user) {
              return (
                <tr key={user.email}>
                  <td>
                    {user.email}
                  </td>
                  <td>
                    {user.student_count}
                  </td>
                  <td>
                  	{user.num_days_active}
                  </td>
                  <td>
                  	{user.days_active}
                  </td>
                  <td>
                  	{ moment(user.date_joined).fromNow() }
                  </td>

                </tr>
              )
            })
          }
          </tbody>

				</table>

      </div>
    );
  }
}

export default withRouter(ActiveNewUsers);



// WEBPACK FOOTER //
// ./src/components/ActiveNewUsers.js